import {Col, Form, InputNumber, Row, Select} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from '../common/WangEditor';
import {sideMenuContext} from '../../../router/IndexRouter';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateEditorContent} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};
const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef();

const AddYearlyReport = () => {
	const currentUrl = window.location.href;
	// 获取 WangEditor 中的内容
	const {editorContent} = useContext(sideMenuContext);
	const apiList = [Arguments.host + '/society_organization/society/api!addYearlyRecognition.do'];

	useEffect(() => {
		formRef.current.setFieldsValue({
			checkContent: editorContent,
		});
	}, [editorContent]);

	return (
		currentUrl.endsWith('add') ? <AddFormComponent UserForm={YearlyInspectionForm} url={apiList}/> :
			<EditFormComponent UserForm={YearlyInspectionForm} url={apiList}/>
	);
};

const YearlyInspectionForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
			ref={formRef}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="year" label="年报年度"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="publicShowState" label="公示状态" rules={[{required: true, message: '内容不能为空'}]}
						initialValue="已公示">
						<Select>
							<Select.Option value="已公示">已公示</Select.Option>
							<Select.Option value="未公示">未公示</Select.Option>
							<Select.Option value="未上报">未上报</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="checkContent" label="年报说明"
						rules={[{required: true, validator: validateEditorContent}]}>
						<WangEditor
							defaultValue={initialValues?.checkContent}
							placehoderText="请在此填写年报说明，若已年报请上传年报公示题图！"
						/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>

		</Form>
	);
};

export default AddYearlyReport;
